import { unixToDate } from '../handle/unix-to-date.handle';

export const handleDescription = (description) => (description.length > 0 ? unixToDate(description[0].created_at) : '-');
